import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../lib/firebase";

const Team = () => {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    const fetchTeam = async () => {
      const snap = await getDocs(collection(db, "team"));
      setTeam(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchTeam();
  }, []);

  return (
    <div className="pt-32 px-6 max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold text-center mb-12">Our Team</h1>

      <div className="grid md:grid-cols-3 gap-8">
        {team.map(member => (
          <div key={member.id} className="text-center">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="w-40 h-40 rounded-full object-cover mx-auto mb-4"
            />
            <h3 className="font-bold text-xl">{member.name}</h3>
            <p className="text-gray-600">{member.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
